// extracted by mini-css-extract-plugin
module.exports = {"xs":"375px","sm":"600px","md":"834px","lg":"1280px","xl":"1280px","topNavBanner":"TopNavBanner-module__topNavBanner___n-UJY","fixed":"TopNavBanner-module__fixed___372T_"};